








































import {
  computed,
  defineComponent,
  useRoute,
  useRouter,
} from "@nuxtjs/composition-api";
import { useUser } from "~/modules/customer/composables/useUser";

export default defineComponent({
  name: "OderFooter",
  components: {},
   props: {
    status: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const { isAuthenticated } = useUser();

  

    const isChangePaymentMethod = computed(() => {
      return (
        isAuthenticated.value &&
        (props.status === "change" ||
          props.status === "cancel" ||
          props.status === "failed")
      );
    });

    const isPaymentAgain = computed(() => {
      return (
        props.status === "change" ||
        props.status === "failed" ||
        props.status === "cancel"
      );
    });

    const payment = () => {
      emit("payment");
    };

    const back = () => {
      emit("cancelPayment", true);
    };

    const changePaymentMethod = () => {
      emit("changePaymentMethod");
    };

    const orderTracking = () => {
      emit("orderTracking");
    };

    const comebackToShopping = () => {
      window.location.href = "/";
    };

    return {
      payment,
      back,
      orderTracking,
      comebackToShopping,
      isPaymentAgain,
      isChangePaymentMethod,
      changePaymentMethod,
    };
  },
});
